/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|http?:|mailto:|tel:)/.test(path);
}
